import { defineStore } from "pinia";
import { ref, reactive } from "vue";

export const useSelectedLabelsStore = defineStore("selectedLabels", () => {
  const formaLente = ref(null);
  const fotocromatico = ref(null);
  const coloracion = ref(null);
  const color = ref(null);
  const tono = ref(null);
  const tratamiento = ref(null);
  const baseEspecialOD = ref(null);
  const baseEspecialOI = ref(null);
  const descentramientoOD = ref(null);
  const descentramientoOI = ref(null);
  const prismaOD = reactive({ prisma1: null, prisma2: null });
  const prismaOI = reactive({ prisma1: null, prisma2: null });
  const biselado = ref(null);
  const montaje = ref(null);
  const precalibrado = ref(null);

  function setFormaLente(label) {
    formaLente.value = label;
  }
  function setFotocromatico(label) {
    fotocromatico.value = label;
  }
  function setColoracion(label) {
    coloracion.value = label;
  }
  function setColor(label) {
    color.value = label;
  }
  function setTono(label) {
    tono.value = label;
  }
  function setTratamiento(label) {
    tratamiento.value = label;
  }
  function setBaseEspecialOD(label) {
    baseEspecialOD.value = label;
  }
  function setBaseEspecialOI(label) {
    baseEspecialOI.value = label;
  }
  function setDescentramientoOD(value) {
    descentramientoOD.value = value;
  }
  function setDescentramientoOI(value) {
    descentramientoOI.value = value;
  }
  function setPrismaOD({ prisma1, prisma2 }) {
    if (prisma1 !== undefined) prismaOD.prisma1 = prisma1;
    if (prisma2 !== undefined) prismaOD.prisma2 = prisma2;
  }
  function setPrismaOI({ prisma1, prisma2 }) {
    if (prisma1 !== undefined) prismaOI.prisma1 = prisma1;
    if (prisma2 !== undefined) prismaOI.prisma2 = prisma2;
  }
  function setBiselado(label) {
    biselado.value = label;
  }
  function setMontaje(label) {
    montaje.value = label;
  }
  function setPrecalibrado(label) {
    precalibrado.value = label;
  }

  function updateFormaLente(label) {
    setFormaLente(label);
  }
  function updateFotocromatico(label) {
    setFotocromatico(label);
  }
  function updateColoracion(label) {
    setColoracion(label);
  }
  function updateColor(label) {
    setColor(label);
  }
  function updateTono(label) {
    setTono(label);
  }
  function updateTratamiento(label) {
    setTratamiento(label);
  }
  function updateBaseEspecialOD(label) {
    setBaseEspecialOD(label);
  }
  function updateBaseEspecialOI(label) {
    setBaseEspecialOI(label);
  }
  function updateDescentramientoOD(value) {
    setDescentramientoOD(value);
  }
  function updateDescentramientoOI(value) {
    setDescentramientoOI(value);
  }
  function updatePrismaOD(payload) {
    setPrismaOD(payload);
  }
  function updatePrismaOI(payload) {
    setPrismaOI(payload);
  }
  function updateBiselado(label) {
    setBiselado(label);
  }
  function updateMontaje(label) {
    setMontaje(label);
  }
  function updatePrecalibrado(label) {
    setPrecalibrado(label);
  }

  function clearLabels() {
    formaLente.value = null;
    fotocromatico.value = null;
    coloracion.value = null;
    color.value = null;
    tono.value = null;
    tratamiento.value = null;
    baseEspecialOD.value = null;
    baseEspecialOI.value = null;
    descentramientoOD.value = null;
    descentramientoOI.value = null;
    prismaOD.prisma1 = null;
    prismaOD.prisma2 = null;
    prismaOI.prisma1 = null;
    prismaOI.prisma2 = null;
    biselado.value = null;
    montaje.value = null;
    precalibrado.value = null;
  }

  return {
    formaLente,
    fotocromatico,
    coloracion,
    color,
    tono,
    tratamiento,
    baseEspecialOD,
    baseEspecialOI,
    descentramientoOD,
    descentramientoOI,
    prismaOD,
    prismaOI,
    biselado,
    montaje,
    precalibrado,
    setFormaLente,
    setFotocromatico,
    setColoracion,
    setColor,
    setTono,
    setTratamiento,
    setBaseEspecialOD,
    setBaseEspecialOI,
    setDescentramientoOD,
    setDescentramientoOI,
    setPrismaOD,
    setPrismaOI,
    setBiselado,
    setMontaje,
    setPrecalibrado,
    updateFormaLente,
    updateFotocromatico,
    updateColoracion,
    updateColor,
    updateTono,
    updateTratamiento,
    updateBaseEspecialOD,
    updateBaseEspecialOI,
    updateDescentramientoOD,
    updateDescentramientoOI,
    updatePrismaOD,
    updatePrismaOI,
    updateBiselado,
    updateMontaje,
    updatePrecalibrado,
    clearLabels,
  };
});
